import apiClient from './apiClient';

export const profileService = {
    getProfile: () => apiClient.get('/profile'),
    updateProfile: (data) => apiClient.patch('/profile', { user: data }),
    deleteAccount: () => apiClient.delete('/profile'),
};
